import { getExportButtonConfig, RESPONSE_CONSTANTS, SEARCH_TYPES, defaultFiltersObj, loadMore, SEARCH_TYPES_DRIVER , defaultFiltersObjDriver, headerButtons} from "./CODPortalConstants";

export const exportUrlsConst = {
  DRIVER: "/fulfilment/v2/export/cod/assignee-summary",
  ORDER: "/fulfilment/v2/export/cod/order-summary",
  SUMMARY: "/fulfilment/v2/export/cod/summary",
}

const StdCodPortalConstants = {
  STD_COD_RECON_CONSTANTS: {
    DRIVERS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Drivers",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "driverName",
            headerName: "Driver Name",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "driverName",
              fieldName: "driverName",
              fieldFullName: "driverName",
              multiple: true,
              key: `autoComplete-driverName`,
              label: "Driver Name",
              items: [],
            },
          },
          {
            field: "totalOrders",
            headerName: "Total COD Orders",
            width: 130,
          },
          {
            field: "codCollected",
            headerName: "Total COD Collected (By Driver)",
            width: 186,
          },
          {
            field: "codReceived",
            headerName: "COD amount recieved (By Dispatcher)",
            width: 180,
          },
          {
            field: "codPending",
            headerName: "Total COD amount Due",
            width: 180,
          },
          {
            field: "vendor",
            headerName: "Vendor Name",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "vendorName",
              fieldName: "vendorName",
              fieldFullName: "vendorName",
              multiple: true,
              key: `autoComplete-vendorName`,
              label: "Vendor",
              items: [],
            },
          },
          {
            field: "actions",
            headerName: "Actions",
            width: 100,
            hide: false,
          },
        ],
        headerButtons,
        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 50,
        },
        defaultFiltersObj: defaultFiltersObjDriver,
        SEARCH_TYPES: SEARCH_TYPES_DRIVER,
      },
    },
    ORDERS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Orders",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "orderNo",
            headerName: "Order Number",
            width: 150,
          },
          {
            field: "deliveryStatus",
            headerName: "Delivery Status",
            width: 186,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryStatus",
              fieldName: "deliveryStatus",
              fieldFullName: "deliveryStatus",
              multiple: true,
              key: `autoComplete-deliveryStatus`,
              label: "Delivery Status",
              items: [],
            },
          },
          {
            field: "orderDate",
            headerName: "Order Date",
            width: 140,
          },
          {
            field: "slot",
            headerName: "Slot",
            width: 140,
          },
          {
            field: "codCollected",
            headerName: "Total COD Collected (By Driver)",
            width: 130,
            hide: false,
          },
          {
            field: "codReceived",
            headerName: "COD Amount Received (By Dispatcher)",
            width: 140,
            hide: false,
          },
          {
            field: "codAmountDue",
            headerName: "Total COD Amount Due",
            width: 180,
            hide: false,
          },
          {
            field: "remarks",
            headerName: "Remarks",
            width: 180,
            hide: false,
          },
          {
            field: "collectionStatus",
            headerName: "Collection Status",
            width: 100,
            hide: false,
          },
        ],
        loadMore,
        defaultFiltersObj,
        SEARCH_TYPES,
      },
    },
    RESPONSE_CONSTANTS,
  },
};
export default StdCodPortalConstants;
